import React from 'react'
import "./ProductDetail121.css"
function ProductDetail121() {
  return (
    <>
    <div>
        <div className="toll-hero">
        {/* <img src="product-img/product4.jpg" alt="toll plaza" /> */}
        <video  className="toll-video" autoPlay loop muted playsInline>
          <source src="video/TPMS_video.mp4" type="video/mp4"/>
        </video>
        <div className="toll-overlay">
          <h1 data-aos="fade-up" className='fw-bold text-center transforming'>Every Vehicle Counts. Every Transaction Matters.<br></br><span className='ai-color'>AI-Powered TPMS</span> </h1>
          <p className='gradient-col1'>
 Intelligent Toll Monitoring | Stronger Revenue Protection | Complete Operational Visibility.</p>
        </div>
      </div>
    </div>
    
    </>
  )
}

export default ProductDetail121;
